import styled from 'styled-components';
import LazyLoadImage from '~/components/utilities/lazyload-image';
import { useBannerContext } from '../context/banner-context';
import { BannerHelpers } from '../utils/use-banner-helpers';
import { IMG_SIZES } from '../config';
import { EnhancedCampaign } from '~/components/casino-shared/types';
import breakpoint from '~/utils/style-utils';

const getContainerGridAreaMobile = (helpers: BannerHelpers) => {
	return helpers.isHorizontalOnMobile ? 'right' : 'top-right';
};

const getContainerGridAreaDesktop = () => {
	return 'top-right';
};

const getImageObjectPositionMobile = (helpers: BannerHelpers) => {
	return helpers.isHorizontalOnMobile ? 'right' : 'center';
};

const getImageObjectPositionDesktop = (data: EnhancedCampaign) => {
	if (data.desktopLayoutType === 'PACKED') {
		return 'left';
	}
	return 'right';
};

const Container = styled.div<{ bannerData: EnhancedCampaign; helpers: BannerHelpers }>`
	pointer-events: none;
	grid-area: ${({ helpers }) => getContainerGridAreaMobile(helpers)};
	align-self: stretch;
	justify-self: stretch;
	position: relative;
	z-index: 1;

	img {
		position: absolute;
		width: 100%;
		height: 100%;
		object-fit: contain;
		object-position: ${({ helpers }) => getImageObjectPositionMobile(helpers)};
	}

	${({ bannerData }) => breakpoint.lg`
			grid-area: ${getContainerGridAreaDesktop()};
	
			img {
				object-position: ${getImageObjectPositionDesktop(bannerData)};
			}
		`}
`;

const SecondForegroundImage: React.FC = () => {
	const {
		data,
		data: { foregroundImage2, url },
		helpers
	} = useBannerContext();

	if (helpers.isAllImagesEnabled && foregroundImage2) {
		return (
			<Container bannerData={data} helpers={helpers}>
				<LazyLoadImage
					src={foregroundImage2.src}
					srcSet={foregroundImage2.srcSet}
					sizes={IMG_SIZES.foreground}
					alt={url ?? ''}
					lazyload={helpers.shouldLazyLoad}
				/>
			</Container>
		);
	}
	return null;
};

export default SecondForegroundImage;
